module.exports = __webpack_public_path__ + "img/jyxz_h.98426f01.png";